/** Characters of markdown a canvas card renders. */
export const MARKDOWN_CARD_EXCERPT_CHARS = 16_000;

/**
 * The top of a markdown document, for a card that only ever shows the top of
 * the page. Whole documents belong in the viewer: react-markdown walks every
 * node on render, and the canvas commits all its nodes in one render, so a
 * long document parsed here holds back every card on the canvas.
 *
 * Cut on a blank line so the excerpt ends between blocks, and close a fence
 * the cut left open.
 */
export function markdownCardExcerpt(
  text: string,
  limitChars: number = MARKDOWN_CARD_EXCERPT_CHARS,
): string {
  if (text.length <= limitChars) return text;
  const head = text.slice(0, limitChars);
  const blockEnd = head.lastIndexOf("\n\n");
  const excerpt = blockEnd > limitChars / 2 ? head.slice(0, blockEnd) : head;
  const fences = excerpt.match(/^ {0,3}```/gm)?.length ?? 0;
  return fences % 2 === 1 ? `${excerpt}\n\`\`\`` : excerpt;
}
